import styled from '@emotion/styled';
import { ReactNode, Children } from 'react';
import { mediaQueries } from '../../../constants';
import { Section } from '../../Section/Section';
import { SectionName } from '../../../observability/tracking/events';

type Props = {
  heading?: string;
  children: ReactNode;
};

/**
 * @deprecated
 * This component has been deprecated. `BlockGrid` should be used instead.
 */
export function ColumnsGridSection({ children, heading }: Props) {
  const childrenLength = Children.toArray(children).length;

  if (childrenLength > 4) {
    throw new Error('Max 4 columns are allowed');
  }

  return (
    <Section
      contentWidth="fullWidth"
      heading={heading}
      sectionToTrack={SectionName.ColumnsGridSection}
    >
      <Grid columns={childrenLength}>{children}</Grid>
    </Section>
  );
}

const Grid = styled.div<{ columns: number }>`
  display: grid;
  align-items: start;
  gap: 30px;
  grid-template-columns: repeat(1, 1fr);

  ${mediaQueries.tablet} {
    grid-template-columns: ${({ columns }) =>
      `repeat(${columns === 2 ? 2 : 1}, 1fr)`};
  }

  ${mediaQueries.desktop} {
    grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
  }
`;
